import type { EnhancedSmartLink } from './smartLinkTypes.ts';

const recencyTimestamp = (link: EnhancedSmartLink): number => {
	const raw = link.updatedAt ?? link.createdAt;
	if (!raw) {
		return Number.NEGATIVE_INFINITY;
	}

	const time = Date.parse(raw);
	return Number.isNaN(time) ? Number.NEGATIVE_INFINITY : time;
};

/**
 * Newest first. Prefers last-modified over created, matching the related-content
 * and incoming-links recency rule. Missing or unparseable dates sort last and
 * keep their original relative order.
 */
export const sortLinksByRecency = (links: readonly EnhancedSmartLink[]): EnhancedSmartLink[] =>
	[...links].sort((left, right) => recencyTimestamp(right) - recencyTimestamp(left));
